import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

const JEA_YEAR = 2023;

export const defaultState = {
  jea2023: {
    list: [],
    listLoading: false,
  },
};

export const mutations = {
  JEA2023_SET_LIST(state, list) {
    state.jea2023.list = list;
  },
  JEA2023_SET_LIST_LOADING(state, isLoading) {
    state.jea2023.listLoading = isLoading;
  },
};

export const getters = {
  getJea2023List: state => state.jea2023.list,
  getJea2023ListIsLoading: state => state.jea2023.listLoading,
};

export const actions = {
  // eslint-disable-next-line no-unused-vars
  callJea2023Approve({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/approve`, data)
      .then(result => result.data);
  },
  // eslint-disable-next-line no-unused-vars
  callJea2023Trigger({ dispatch }, data) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/trigger`, data)
      .then(result => result.data);
  },
  fetchJea2023List({ commit }, filterByStatus) {
    commit('JEA2023_SET_LIST_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea?filter_by_status=${filterByStatus}`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { jeas } = response;
          commit('JEA2023_SET_LIST_LOADING', false);
          commit('JEA2023_SET_LIST', jeas);
        });
      })
      .catch((error) => {
        commit('JEA2023_SET_LIST_LOADING', false);
        commit('JEA2023_SET_LIST', []);

        return Promise.reject(error);
      });
  },
  fetchJea2023All({ dispatch }, filterByStatus) {
    dispatch('fetchJea2023List', filterByStatus);
  },
  // eslint-disable-next-line no-unused-vars
  fetchJea2023DownloadPdf({ commit }, requestData) {
    const { id } = requestData;

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_JEA}${JEA_YEAR}/jea/pdf/${id}`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },
};

const jea2023 = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default jea2023;



// WEBPACK FOOTER //
// ./src/store/payout/jea2023.js